import { graphql, HttpResponse } from 'msw'
import { type EnrollmentCashEquivalentData, type EnrollmentCashEquivalentSubmitOutput } from '../../../models'
import { CashEquivalentCategory, InvestmentRiskToleranceCategory } from '../../../models/enrollment/enrollment'

export const getEnrollmentCashEquivalentDataMock: EnrollmentCashEquivalentData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/cash-equivalent',
  enrollmentData: {
    recommendation: {
      investment: {
        cashEquivalentType: {
          allowTripleTaxFreeMunicipalMutualFund: false,
          recommended: CashEquivalentCategory.Corporate,
        },
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const submitEnrollmentCashEquivalentDataMock: EnrollmentCashEquivalentSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/portfolio-customized',
  enrollmentData: {
    recommendation: {
      investment: {
        cashEquivalentType: {
          allowTripleTaxFreeMunicipalMutualFund: false,
          recommended: CashEquivalentCategory.National,
        },
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const mockGetEnrollmentCashEquivalentData = graphql.mutation('getEnrollmentCashEquivalentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentCashEquivalentDataMock } })
})

export const mockSubmitEnrollmentCashEquivalentData = graphql.mutation('submitEnrollmentCashEquivalentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentCashEquivalentDataMock } })
})

export const mockEnrollmentCashEquivalent = [
  mockGetEnrollmentCashEquivalentData,
  mockSubmitEnrollmentCashEquivalentData,
]
